import { LOW_STOCK_CONFIG, ThresholdConfig, LowStockVariantId } from './low-stock-threshold-config';
import { ProductMetaCode } from '@services/MarppleShop/features/ProductMeta';

export interface IMetaCodeVariant {
  getCode(): ProductMetaCode;
  getVariant(): string;
}

export class LowStockMeta implements IMetaCodeVariant {
  private readonly variant: LowStockVariantId;
  private readonly config: ThresholdConfig;

  constructor(variant: LowStockVariantId) {
    this.variant = variant;
    this.config = LOW_STOCK_CONFIG[variant];

    if (!this.config) {
      throw new Error(`Unsupported variant: ${variant}`);
    }
  }

  getCode(): ProductMetaCode {
    return ProductMetaCode.LOW_STOCK;
  }

  getVariant(): LowStockVariantId {
    return this.variant;
  }

  shouldShowLowStock(current_stock: number): boolean {
    return current_stock < this.config.threshold;
  }

  static create(variant: LowStockVariantId): LowStockMeta {
    return new LowStockMeta(variant);
  }
}
